module.exports = __webpack_public_path__ + "img/company.e772fcce.svg";